import { CaretDown } from '@phosphor-icons/react';

import { useAuth } from '@/lib/auth/AuthContext';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/ui/dropdown-menu';

const ROLE_LABEL: Record<string, string> = {
    PARTNER_ADMIN: 'Partner admin',
    DEVELOPER: 'Developer',
    FINANCE: 'Finance',
    VIEWER: 'Viewer',
};

export function UserMenu() {
    const { user, signOut } = useAuth();
    if (!user) return null;

    return (
        <DropdownMenu>
            <DropdownMenuTrigger className="group inline-flex items-center gap-2 rounded-md border border-transparent px-2 py-1 transition-colors hover:border-border hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary/10 text-2xs font-semibold text-primary">
                    {user.initials}
                </span>
                <span className="hidden flex-col items-start leading-tight sm:flex">
                    <span className="text-xs font-medium text-foreground">{user.fullName}</span>
                    {user.partnerName ? (
                        <span className="text-2xs text-muted-foreground">{user.partnerName}</span>
                    ) : null}
                </span>
                <CaretDown
                    weight="regular"
                    className="h-3 w-3 text-muted-foreground transition-transform group-data-[state=open]:rotate-180"
                />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuLabel>{user.email}</DropdownMenuLabel>
                <DropdownMenuItem disabled>
                    Role · {ROLE_LABEL[user.role] ?? user.role}
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onSelect={() => signOut()}>Sign out</DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
